import React, { useState, useEffect, useRef } from "react";
import { isPlayerSupported, create } from "amazon-ivs-player";

const IVSPlayer = () => {
  const videoRef = useRef(null);
  const [playbackUrl, setPlaybackUrl] = useState(
    "https://fcc3ddae59ed.us-west-2.playback.live-video.net/api/video/v1/us-west-2.893648527354.channel.DmumNckWFTqz.m3u8"
  );
  let player = null; // Initialize player as null

  useEffect(() => {
    if (!isPlayerSupported) {
      console.error("IVS Player is not supported!");
      return;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    player = create({
      wasmWorker: "/assets/amazon-ivs-wasmworker.min.js",
      wasmBinary: "/assets/amazon-ivs-wasmworker.min.wasm",
      serviceWorker: {
        // NOTE: downloaded from: https://player.live-video.net/1.24.0/amazon-ivs-service-worker.min.js
        url: "amazon-ivs-service-worker.min.js",
      },
    });
    player.setLogLevel("debug");
    const videoElement = videoRef.current;

    player.attachHTMLVideoElement(videoElement);
    player.load(playbackUrl);
    player.play();

    return () => {
      if (player) {
        player.delete();
      }
    };
  }, [playbackUrl]);

  const handleUrlChange = (event) => {
    setPlaybackUrl(event.target.value);
  };

  return (
    <div>
      <input
        type="text"
        value={playbackUrl}
        onChange={handleUrlChange}
        placeholder="Enter Playback URL"
        className="playback-url-input" /* Add the class */
      />
      <div>
        <video
          ref={videoRef}
          id="player"
          playsInline
          controls
          crossOrigin="anonymous"
          className="player-container"
        />
      </div>
    </div>
  );
};

export default IVSPlayer;
